<template>
  <v-fade-transition>
  <wgu-map-overlay
    overlayId="tooltip-utiefe"
    :visible=false
    autoPan
    :autoPanDuration="250"
    :offset="[0, 20]"
    positioning="top-center"
  >
    <v-card
      width="auto"
      slot-scope="{feature}"
      v-if="feature && feature.get('label')"
      class="tooltipBorder"
      >
      <v-btn
      elevation="2"
      icon
      small
      style="float:right; vertical-align: top; transform: translate(0.75em, -0.75em); background-color: white"
      @click="closeTooltip()"
    >
    <v-icon>close</v-icon>
    </v-btn>
      <v-card-title>
        <!--<img class="topicIconTooltip" src="static/icon/symbolHochwasser.png" v-if="showTooltipIcon(feature, 'H')"/>
        <img class="topicIconTooltip" src="static/icon/symbolGrundwasser.png" v-if="showTooltipIcon(feature, 'G')" />
        <img class="topicIconTooltip" src="static/icon/symbolStarkregen.png" v-if="showTooltipIcon(feature, 'S')" />-->
        <span class="tooltipFontSize"><!-- TODO d-none d-xs-inline möglich -->
           {{ $t('tooltip_class.' + feature.get('label')).split('|')[0] }}:&nbsp;
         </span>
         <span class="tooltipFontSize">
           {{ $t('tooltip_class.' + feature.get('label')).split('|')[1]  }}
        </span >
      </v-card-title>
    </v-card>
  </wgu-map-overlay>
</v-fade-transition>
</template>

<script>
import MapOverlay from '../src/components/modulecore/MapOverlay.vue'
import { WguEventBus } from '../src/WguEventBus'
export default {
  name: 'tooltip-utiefe',
  components: {
    'wgu-map-overlay': MapOverlay
  },
  data () {
    return {
      showTooltip: false,
      sizeClass: 'x-small'
    }
  },
  methods: {
    closeTooltip () {
      WguEventBus.$emit('tooltip-utiefe-update-overlay', true);
    },
    showTooltipIcon (f, targetTopic) {
      if (f) {
        if (f.get('label')) {
          return f.get('label')[0] === targetTopic;
        }
      }

      return false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.v-card__title {
  padding: 8px !important;
}

.topicIconTooltip {
  display: none;
}

.tooltipBorder {
  border: 2px solid #91c9ff80 !important;
  border-radius: 1em;
}

.tooltipFontSize {
  font-size: 0.8em;
}

@media (min-width: 800px) {

  .topicIconTooltip {
    display: block;
    height: 2.2em;
    padding: 1px;
    padding-right: 1px;
  }
}

@media (min-width: 1000px) {

  .tooltipFontSize {
    font-size: 1em;
  }

  .topicIconTooltip {
    display: block;
    height: 3em;
    padding: 2px;
    padding-right: 2px;
  }
}

@media (min-width: 1500px) {
  .tooltipFontSize {
    font-size: 1.15em;
  }
}

@media (max-width: 700px) {

  .v-btn--icon.v-size--small {
      height: 20px !important;
      width: 20px !important;
    }
  .v-btn--icon.v-size--small .v-icon {
      height: 16px !important;
      font-size: 16px !important;
      width: 16px !important;
    }

  .v-card__title {
    padding: 6px !important;
  }
}

@media (max-width: 600px) {

.v-card__title {
    padding: 6px !important;
  }

}
</style>
